//////////////////////////////

module.exports = (type) => {
    var schema = {
        customer_id: {
            type: type.INTEGER,
            allowNull: false,
            references: {
                model       : 'customers',
                key         : 'id',
                constraints : true,
                store_name  : 'customer',
            }
        },
        label: {
            type: type.STRING(64),
            allowNull: false,
        },
        type: {
            type: type.STRING(24),
            allowNull: false,
        },
        denominazione: {
            type: type.STRING(128),
            allowNull : false,
        },
        created: {
            type: type.DATE,
            allowNull: false,
            defaultValue: type.NOW,
        },
        config: {
            type: type.JSONB,
            allowNull: false,
            defaultValue: {},
        },
        id: {
            type: type.INTEGER,
            primaryKey: true,
            autoIncrement: true
        },
    };

    return schema;
}

